import * as React from 'react'

interface Props {
  to: string
  ariaLabel?: string
  children: React.ReactNode
}
function FooterLink({ to, ariaLabel, children }: Props) {
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener"
      aria-label={ariaLabel}
      style={{ color: 'inherit', textDecoration: 'none' }}
    >
      {children}
    </a>
  )
}

export { FooterLink }
